/** 原子件：状态标签与布尔标签。
 *
 * 语义色只有四个（正常 / 注意 / 危险 / 停手），其余一律中性——变量名沿用原型
 * `styles.css` 的 `.pill.*`，所以原型屏与 React 屏的观感可以直接对照。
 */

import type { ReactNode } from "react";

export type PillTone = "ok" | "warn" | "bad" | "halt" | "info" | "neutral";

export function Pill({ tone = "neutral", children }: { tone?: PillTone; children: ReactNode }): ReactNode {
  return <span className={`pill ${tone}`}>{children}</span>;
}

/** 是 / 否 两态，色由调用点给默认值。 */
export function BoolPill({
  value,
  yes = "是",
  no = "否",
  toneOk = "ok",
  toneBad = "neutral",
}: {
  value: boolean;
  yes?: string;
  no?: string;
  toneOk?: PillTone;
  toneBad?: PillTone;
}): ReactNode {
  return value ? <Pill tone={toneOk}>{yes}</Pill> : <Pill tone={toneBad}>{no}</Pill>;
}

/** 订单 / 成交状态 → 色。任何「停止 / 不平 / 越界」都必须有色，不许只用文案。 */
export function statusTone(status: string): PillTone {
  switch (status) {
    case "FILLED":
      return "ok";
    case "REJECTED":
      return "bad";
    case "CANCELED":
      return "warn";
    case "SUBMITTED":
    case "ACCEPTED":
      return "info";
    default:
      return "neutral";
  }
}

export function SidePill({ side }: { side: string | null }): ReactNode {
  if (side === "BUY") return <Pill tone="info">BUY</Pill>;
  if (side === "SELL") return <Pill tone="warn">SELL</Pill>;
  return <Pill tone="neutral">{side ?? "—"}</Pill>;
}
